import { createContext } from "react";
import { TnCContextType } from "../types/tnc";


export const TnCContext = createContext<TnCContextType | undefined>(undefined);
